const CSRF_SELECTOR = 'meta[name=csrf-token]';
let token = null;

export default function getCSRFToken(scope = document) {
  if (token) {
    return token;
  }
  const tokenNode = scope.querySelector(CSRF_SELECTOR);
  if (tokenNode) {
    token = tokenNode.getAttribute('content');
  }
  return token || '';
}
